import {
	Box,
	Typography,
	TextField,
	Checkbox,
	FormControlLabel,
	Button,
	Grid,
	Paper,
	Divider,
	FormGroup,
	FormControl,
	RadioGroup,
	Radio,
	CircularProgress,
	Stack,
	FormHelperText,
	Modal,
	List,
	ListItem,
	ListItemText,
	Link
} from '@mui/material';

import { InputText } from '../../components/Inputs/InputText';
import { useLang } from '../../language';

export const FormSolicitud = ({
	params, 
	loadingParams, 
	loadingCliente, 
	formSolicitudOtc, 
	handleInputSolicitudOtc, 
	errorEnvioSolicitud, 
	validOTEC, 
	handleFormSolicitudOtc, 
	handleGuardarSolictudSubmit, 
	loadingSolicitud,
	solicitudId
	}:any) => {

	const Lang = useLang()

	const handleActividadesProfesionalesChange = (e: any) => {
		const { value, checked } = e.target;
		const id = Number(value);

		handleFormSolicitudOtc({
			...formSolicitudOtc,
			actividades_profesionales: checked
				? formSolicitudOtc.actividades_profesionales.includes(id)
					? formSolicitudOtc.actividades_profesionales
					: [...formSolicitudOtc.actividades_profesionales, id]
				: formSolicitudOtc.actividades_profesionales.filter((item: number) => item !== id)
		});
	};

	/*const handleProyectosChange = (e: any) => {
		const { value, checked } = e.target;
		const id = Number(value);

		handleFormSolicitudOtc({
			...formSolicitudOtc,
			proyectos: checked
				? formSolicitudOtc.proyectos.includes(id)
					? formSolicitudOtc.proyectos
					: [...formSolicitudOtc.proyectos, id]
				: formSolicitudOtc.proyectos.filter((item: number) => item !== id)
		});
	};*/

	const handleProyectosChange = (e: any, proyectoData: any) => {
	  const { value, checked } = e.target;
	  const id = Number(value);

	  const grupo = Object.values(proyectoData).find(
	    (g: any) => Number((g as any).id_parametro) === id
	  ) as any;

	  const hijosIds = grupo?.hijos
	    ? Object.values(grupo.hijos).map((h: any) => Number(h.id_parametro))
	    : [];

	  let nuevosProyectos: number[] = [];

	  if (checked) {
	    nuevosProyectos = formSolicitudOtc.proyectos.includes(id)
	      ? formSolicitudOtc.proyectos
	      : [...formSolicitudOtc.proyectos, id];
	  } else {
	    nuevosProyectos = formSolicitudOtc.proyectos.filter((item: number) => item !== id);

	    if (grupo) {
	      nuevosProyectos = nuevosProyectos.filter(
	        (item: number) => !hijosIds.includes(item)
	      );
	    }
	  }

	  handleFormSolicitudOtc({
	    ...formSolicitudOtc,
	    proyectos: nuevosProyectos,
	  });
	};


	const handleTerritoriosChange = (e: any) => {
		const { value, checked } = e.target;
		const id = Number(value);

		handleFormSolicitudOtc({
			...formSolicitudOtc,
			territorios: checked
				? formSolicitudOtc.territorios.includes(id)
					? formSolicitudOtc.territorios
					: [...formSolicitudOtc.territorios, id]
				: formSolicitudOtc.territorios.filter((item: number) => item !== id)
		});
	};

	const handlePolizaChange = (e: any) => {
		const { name, checked } = e.target;

		handleFormSolicitudOtc({
			...formSolicitudOtc,
			[name]: checked ? 1 : 0
		});
	};

	const handlePrimeraVisitaChange = (e: any) => {
		handleFormSolicitudOtc({
			...formSolicitudOtc,
			primera_visita_gratuita: Number(e.target.value)
		});
	};

	const handleAceptaCondicionsChange = (e: any) => {
		const { name, checked } = e.target;

		handleFormSolicitudOtc({
			...formSolicitudOtc,
			[name]: checked ? true : false
		});
	};

	return (
		<Grid container spacing={3} justifyContent="center" >
			<Grid item xs={12} lg={12} xl={11} className='mb-4 pb-2 xxl-8'>
				<Paper className='p-3 p-md-4'>
					<Typography variant='h6' className="my-0 pb-2 fw-500 color-primary text-center">
						{Lang('FORMULARIO_OTED_TITULO')}
					</Typography>

					<Box component="form" sx={{ mt: 3 }}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4}>
								<InputText
									fullWidth
									variant="standard"
									label={Lang('FORMULARIO_OTED_INPUT_NOMBRE')}
									name="nombre_completo"
									value={formSolicitudOtc.nombre_completo}
									onChange={handleInputSolicitudOtc}
									serverErrors={errorEnvioSolicitud?.errors}
									disabled={true}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<InputText
									fullWidth
									variant="standard"
									label={Lang('FORMULARIO_OTED_INPUT_N_COLEGIADO')}
									name="num_colegiado"
									value={formSolicitudOtc.num_colegiado}
									onChange={handleInputSolicitudOtc}
									serverErrors={errorEnvioSolicitud?.errors}
									disabled={true}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<InputText
									fullWidth
									variant="standard"
									label={Lang('FORMULARIO_OTED_INPUT_ESPECIALIDAD')}
									name="titulo_especializado"
									value={formSolicitudOtc.titulo_especializado}
									onChange={handleInputSolicitudOtc}
									serverErrors={errorEnvioSolicitud?.errors}
									disabled={true}
								/>
							</Grid>
	
							<Grid item xs={12} sm={6}>
								<InputText
									fullWidth
									variant="standard"
									label={Lang('FORMULARIO_OTED_INPUT_TELEFONO')}
									name="telefono_contacto"
									value={formSolicitudOtc.telefono_contacto}
									onChange={handleInputSolicitudOtc}
									serverErrors={errorEnvioSolicitud?.errors}
									localValidation={validOTEC.telefono_contacto}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<InputText
									fullWidth
									variant="standard"
									label={Lang('FORMULARIO_OTED_INPUT_CORREO')}
									name="correo"
									type="email"
									value={formSolicitudOtc.correo}
									onChange={handleInputSolicitudOtc}
									serverErrors={errorEnvioSolicitud?.errors}
									localValidation={validOTEC.correo}
								/>
							</Grid>

							{/* Actividades profesionales */}
							<Grid item xs={12}>
								<FormControl component="fieldset" sx={{ mt: 2 }}>
									<Typography variant="subtitle1" className="mb-4 fw-500 color-primary">
										{params?.data?.activitats_professionals?.valor || 'Activitats professionals'}
									</Typography>
									<FormGroup>
										{params?.data?.activitats_professionals?.hijos?.map((actividad: any) => (
											<FormControlLabel
												key={actividad.id_parametro}
												control={
													<Checkbox
														name="actividades_profesionales"
														value={actividad.id_parametro}
														checked={formSolicitudOtc.actividades_profesionales.includes(Number(actividad.id_parametro))}

														onChange={handleActividadesProfesionalesChange}
													/>
												}
												label={actividad.valor}
											/>
										))}
									</FormGroup>
								</FormControl>
								{errorEnvioSolicitud?.errors?.actividades_profesionales && (
									<FormHelperText
										sx={{
											color: 'error.main',
											mt: 1,
											mb: 0
										}}
									>
										{errorEnvioSolicitud.errors.actividades_profesionales.join(' ')}
									</FormHelperText>
								)}
							</Grid>

							{/* Sección de proyectos */}
							<Grid item xs={12}>
								<Stack spacing={1} sx={{ mb: 2 }}>
									<Typography variant="h5" sx={{ fontWeight: 700 }}>
										{Lang('FORMULARIO_OTED_MANIFESTO')}
									</Typography>
								</Stack>

								<Divider sx={{ mb: 3 }} />

								{/* Cuerpo */}
								<Stack spacing={2} className='mb-3'>
									<Typography component="p">
										1.- Que he estat informat de la creació de la{' '}
										<strong>Xarxa d’Oficines Empresarials i Col·legials d'Impuls a la Transició Energètica de Catalunya</strong>,
										amb el suport de la <strong>Generalitat de Catalunya</strong> (Departament de Territori, Habitatge i
										Transició Ecològica) i coordinat per l’<strong>Institut Català d’Energia</strong>.
									</Typography>

									<Typography component="p">
										2.- Que estic assabentat que el{' '}
										<strong>Col·legi d’Enginyers Tècnics Industrials de Barcelona</strong> (en endavant “<strong>el Col·legi</strong>”)
										està constituïda com una de les <strong>Oficines de Transició Energètica Col·legial (OTEC)</strong> de Catalunya i
										que està ubicada al <strong>c/ Consell de Cent, 365, Barcelona</strong>, donant servei d’atenció, orientació i
										acompanyament al teixit empresarial, dins del seu territori d’influència.
									</Typography>

									<Typography component="p">
										3.- Que l’oficina contactarà i oferirà a les empreses del territori que progressin i actuïn en l’àmbit de la
										transició energètica. Per dur a terme les actuacions que se’n puguin derivar, promocionarà els serveis
										professionals dels seus col·legiats, que declarin disposar de coneixements energètics per dur a terme
										projectes de <strong>cinc línies d’actuació</strong> possibles i/o suport en tràmits, permisos i subvencions,
										vinculades a aquestes.
									</Typography>

									<Typography component="p">
										4.- Que per tal efecte, i fins la finalització de l’activitat de l’OTEC (
										<strong>febrer 2027 amb possibilitat de pròrroga</strong>) s’inclourà al portal <strong>WEB d’ENGINYERS BCN</strong> una nova oferta de
										professionals <strong>ETEC</strong> a la que l’oficina adreçarà específicament les empreses per tal que els
										contactin i arribar a un acord, que generi la contractació dels serveis necessaris que requereixin en cada cas.
									</Typography>

									<Typography component="p">
										5.- Que fruit de la subvenció que <strong>ENGINYERS BCN</strong> rep de la Generalitat de Catalunya, per a dur
										a terme aquest projecte, es desprèn que <strong>l’OTEC</strong> ha de mantenir un acompanyament de les
										actuacions i n’ha de recollir els resultats en base a uns indicadors estadístics prefixats.
									</Typography>

									<Typography component="p">
										6.- Que per aquest motiu, <strong>l’ETEC</strong> haurà de col·laborar amb <strong>l’OTEC</strong> mantenint-la informada de
											qualsevol contacte rebut per part d’una empresa interessada en algun dels àmbits d’actuació,
											així com de la seva evolució i del resultat final de la seva intervenció. 
									</Typography>

									<Divider sx={{ my: 2 }} />

									<Typography component="p">
										Per això, ambdues parts es comprometen, el Col·legi a incorporar en el llistat <strong>ETEC</strong> al col·legiat/ada i aquest a informar de qualsevol possible actuació en l’àmbit de la transició energètica d’empreses que, directament hagi generat (voluntari) o derivada des de <strong>l’OTEC</strong>, amb subjecció als següents acords:
									</Typography>

									<Typography variant="h6" sx={{ fontWeight: 700, mt: 1 }}>
										{Lang('FORMULARIO_OTED_ACUERDOS')}
									</Typography>

									<Typography component="p">
										1. Que el/la sotasignat/da declara disposar d’<strong>amplis coneixements</strong> i vol incorporar-se al
										llistat <strong>ETEC</strong> per oferir els seus serveis professionals en els següents <strong>àmbits d’actuació</strong>:
									</Typography>

								</Stack>

								<FormGroup>

								<Grid container spacing={1}>
								  {params?.data?.proyecto?.projectes_de_generaci_d_energia_renovable && (
								    <Grid item container spacing={1}>
								      <Grid item xs={12}>
								        <FormControlLabel
								          control={
								            <Checkbox
								              name={'proyectos'}
								              value={params?.data?.proyecto?.projectes_de_generaci_d_energia_renovable.id_parametro}
								              checked={formSolicitudOtc.proyectos.includes(
								                Number(params.data.proyecto.projectes_de_generaci_d_energia_renovable.id_parametro)
								              )}
								              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
								            />
								          }
								          label={params.data.proyecto.projectes_de_generaci_d_energia_renovable.valor}
								          sx={{ fontWeight: 500, color: '#9e0054' }}
								        />
								      </Grid>

								      {Object.values(params.data.proyecto.projectes_de_generaci_d_energia_renovable.hijos)
										  .filter((proyecto: any) => proyecto.solo_lectura !== '1')
										  .map((proyecto: any) => (
										    <Grid item xs={12} key={proyecto.id_parametro}>
										      <Box ml={4}> 
										        <FormControlLabel
										          control={
										            <Checkbox
										              name={'proyectos'}
										              value={proyecto.id_parametro}
										              checked={formSolicitudOtc.proyectos.includes(Number(proyecto.id_parametro))}
										              disabled={
										                !formSolicitudOtc.proyectos.includes(
										                  Number(params.data.proyecto.projectes_de_generaci_d_energia_renovable.id_parametro)
										                )
										              }
										              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
										            />
										          }
										          label={proyecto.valor}
										        />
										      </Box>
										    </Grid>
										  ))}
								    </Grid>
								  )}
								</Grid>

									<Divider className='mt-4 mb-4' />
									<Grid container spacing={2}>
										{params?.data?.proyecto?.projectes_d_emmagatzematge_d_energia_de_fonts_renovables && (
											<Grid item container spacing={2}>
												<Grid item xs={12}>
													<FormControlLabel
														control={
															<Checkbox
																name={'proyectos'}
																value={params?.data?.proyecto?.projectes_d_emmagatzematge_d_energia_de_fonts_renovables.id_parametro}
																checked={formSolicitudOtc.proyectos.includes(Number(params.data.proyecto.projectes_d_emmagatzematge_d_energia_de_fonts_renovables.id_parametro))}
																onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
															/>
														}
														label={params.data.proyecto.projectes_d_emmagatzematge_d_energia_de_fonts_renovables.valor}
														sx={{ fontWeight: 500, color: '#9e0054' }}
													/>
												</Grid>
											</Grid>
										)}
									</Grid>
									<Divider className='mt-4 mb-4' />

								    <Grid container spacing={1}>
									  {params?.data?.proyecto?.projectes_de_mobilitat_el_ctrica && (
									    <Grid item container spacing={1}>
									      <Grid item xs={12}>
									        <FormControlLabel
									          control={
									            <Checkbox
									              name={'proyectos'}
									              value={params?.data?.proyecto?.projectes_de_mobilitat_el_ctrica.id_parametro}
									              checked={formSolicitudOtc.proyectos.includes(
									                Number(params.data.proyecto.projectes_de_mobilitat_el_ctrica.id_parametro)
									              )}
									              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
									            />
									          }
									          label={params.data.proyecto.projectes_de_mobilitat_el_ctrica.valor}
									          sx={{ fontWeight: 500, color: '#9e0054' }}
									        />
									      </Grid>

									      {Object.values(params.data.proyecto.projectes_de_mobilitat_el_ctrica.hijos)
											  .filter((proyecto: any) => proyecto.solo_lectura !== '1')
											  .map((proyecto: any) => (
											    <Grid item xs={12} key={proyecto.id_parametro}>
											      <Box ml={4}> 
											        <FormControlLabel
											          control={
											            <Checkbox
											              name={'proyectos'}
											              value={proyecto.id_parametro}
											              checked={formSolicitudOtc.proyectos.includes(Number(proyecto.id_parametro))}
											              disabled={
											                !formSolicitudOtc.proyectos.includes(
											                  Number(params.data.proyecto.projectes_de_mobilitat_el_ctrica.id_parametro)
											                )
											              }
											              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
											            />
											          }
											          label={proyecto.valor}
											        />
											      </Box>
											    </Grid>
											  ))}
									    </Grid>
									  )}
									</Grid>

									<Divider className='mt-4 mb-4' />
									<Grid container spacing={2} className='mb-4'>
										{params?.data?.proyecto?.projectes_de_comunitats_energ_tiques && (
											<Grid item container spacing={2}>
												<Grid item xs={12}>
													<FormControlLabel
														control={
															<Checkbox
																name={'proyectos'}
																value={params?.data?.proyecto?.projectes_de_comunitats_energ_tiques.id_parametro}
																checked={formSolicitudOtc.proyectos.includes(Number(params.data.proyecto.projectes_de_comunitats_energ_tiques.id_parametro))}
																onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
															/>
														}
														label={params.data.proyecto.projectes_de_comunitats_energ_tiques.valor}
														sx={{ fontWeight: 500, color: '#9e0054' }}
													/>
												</Grid>
											</Grid>
										)}
									</Grid>

									<Divider className='mt-4 mb-4' />

									<Grid container spacing={1}>
									  {params?.data?.proyecto?.projectes_d_efici_ncia_energ_tica && (
									    <Grid item container spacing={1}>
									      <Grid item xs={12}>
									        <FormControlLabel
									          control={
									            <Checkbox
									              name={'proyectos'}
									              value={params?.data?.proyecto?.projectes_d_efici_ncia_energ_tica.id_parametro}
									              checked={formSolicitudOtc.proyectos.includes(
									                Number(params.data.proyecto.projectes_d_efici_ncia_energ_tica.id_parametro)
									              )}
									              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
									            />
									          }
									          label={params.data.proyecto.projectes_d_efici_ncia_energ_tica.valor}
									          sx={{ fontWeight: 500, color: '#9e0054' }}
									        />
									      </Grid>

									      {Object.values(params.data.proyecto.projectes_d_efici_ncia_energ_tica.hijos)
											  .filter((proyecto: any) => proyecto.solo_lectura !== '1')
											  .map((proyecto: any) => (
											    <Grid item xs={12} key={proyecto.id_parametro}>
											      <Box ml={4}> 
											        <FormControlLabel
											          control={
											            <Checkbox
											              name={'proyectos'}
											              value={proyecto.id_parametro}
											              checked={formSolicitudOtc.proyectos.includes(Number(proyecto.id_parametro))}
											              disabled={
											                !formSolicitudOtc.proyectos.includes(
											                  Number(params.data.proyecto.projectes_d_efici_ncia_energ_tica.id_parametro)
											                )
											              }
											              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
											            />
											          }
											          label={proyecto.valor}
											        />
											      </Box>
											    </Grid>
											  ))}
									    </Grid>
									  )}
									</Grid>

									<Divider className='mt-4 mb-4' />

									<Grid container spacing={1}>
									  {params?.data?.proyecto?.tr_mits_permisos_subvencions && (
									    <Grid item container spacing={1}>
									      <Grid item xs={12}>
									        <FormControlLabel
									          control={
									            <Checkbox
									              name={'proyectos'}
									              value={params?.data?.proyecto?.tr_mits_permisos_subvencions.id_parametro}
									              checked={formSolicitudOtc.proyectos.includes(
									                Number(params.data.proyecto.tr_mits_permisos_subvencions.id_parametro)
									              )}
									              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
									            />
									          }
									          label={params.data.proyecto.tr_mits_permisos_subvencions.valor}
									          sx={{ fontWeight: 500, color: '#9e0054' }}
									        />
									      </Grid>

									      {Object.values(params.data.proyecto.tr_mits_permisos_subvencions.hijos)
											  .filter((proyecto: any) => proyecto.solo_lectura !== '1')
											  .map((proyecto: any) => (
											    <Grid item xs={12} key={proyecto.id_parametro}>
											      <Box ml={4}> 
											        <FormControlLabel
											          control={
											            <Checkbox
											              name={'proyectos'}
											              value={proyecto.id_parametro}
											              checked={formSolicitudOtc.proyectos.includes(Number(proyecto.id_parametro))}
											              disabled={
											                !formSolicitudOtc.proyectos.includes(
											                  Number(params.data.proyecto.tr_mits_permisos_subvencions.id_parametro)
											                )
											              }
											              onChange={(e) => handleProyectosChange(e, params.data.proyecto)}
											            />
											          }
											          label={proyecto.valor}
											        />
											      </Box>
											    </Grid>
											  ))}
									    </Grid>
									  )}
									</Grid>

								</FormGroup>

								{errorEnvioSolicitud?.errors?.proyectos && (
									<FormHelperText
										sx={{
											color: 'error.main',
											mt: 1,
											mb: 0
										}}
									>
										{errorEnvioSolicitud.errors.proyectos.join(' ')}
									</FormHelperText>
								)}

								{/* Sección de territorios */}
								<Divider className='mt-4 mb-4' />
								<Typography variant="subtitle1" className="fw-500 mb-3 color-primary">2. {params?.data?.territorios?.valor || "Territori d'influència"}</Typography>
								<Grid container spacing={2}>
									{params?.data?.territorios?.hijos?.map((territorio: any) => (
										<Grid item xs={12} sm={6} md={4} key={territorio.id_parametro}>
											<FormControlLabel
												control={
													<Checkbox
														name={'territorios'}
														value={territorio.id_parametro}
														checked={formSolicitudOtc.territorios.includes(Number(territorio.id_parametro))}
														onChange={handleTerritoriosChange}
													/>
												}
												label={territorio.valor}
											/>
										</Grid>
									))}
								</Grid>
								{errorEnvioSolicitud?.errors?.territorios && (
									<FormHelperText
										sx={{
											color: 'error.main',
											mt: 1,
											mb: 0
										}}
									>
										{errorEnvioSolicitud.errors.territorios.join(' ')}
									</FormHelperText>
								)}
							</Grid>

							{/* Sección de póliza */}
							<Grid item xs={12}>
								<Divider className='mt-4 mb-4' />
								<Typography variant="subtitle1" className='mb-4 fw-500 color-primary' sx={{ mt: 2 }}>
									3.- Que el /la sotasignant disposa de pòlissa vigent de responsabilitat civil professional en la modalitat de:
								</Typography>

								<FormGroup className="mb-4">
									<FormControlLabel
										className='mb-4'
										control={
											<Checkbox
												name="poliza_colegio"
												checked={formSolicitudOtc.poliza_colegio}
												onChange={handlePolizaChange}
											/>
										}
										label={Lang('POLZA_COLEGIADO')}
									/>
									<FormControlLabel
										control={
											<Checkbox
												name="poliza_externa"
												checked={formSolicitudOtc.poliza_externa}
												onChange={handlePolizaChange}
											/>
										}
										label={
										    <span dangerouslySetInnerHTML={{ __html: Lang('POLZA_EXTERNA') }} />
										  }
									/>
								</FormGroup>

								{/*(formSolicitudOtc.poliza_externa > 0) &&*/}
								{true &&
									<>
										<InputText
											fullWidth
											variant="standard"
											label={Lang('FORMULARIO_OTED_INPUT_COMPANIA')}
											name="compania_seguros"
											value={formSolicitudOtc.compania_seguros}
											onChange={handleInputSolicitudOtc}
											sx={{ mt: 2 }}
											disabled={!formSolicitudOtc.poliza_externa}
											serverErrors={errorEnvioSolicitud?.errors}
										/>
										<Grid container spacing={2} sx={{ mt: 1 }}>
											<Grid item xs={12} sm={6}>
												<InputText
													fullWidth
													variant="standard"
													label={Lang('FORMULARIO_OTED_INPUT_N_POLZA')}
													name="num_poliza"
													value={formSolicitudOtc.num_poliza}
													onChange={handleInputSolicitudOtc}
													disabled={!formSolicitudOtc.poliza_externa}
													serverErrors={errorEnvioSolicitud?.errors}
												/>
											</Grid>
											<Grid item xs={12} sm={6}>
												<InputText
													fullWidth
													variant="standard"
													label={Lang('FORMULARIO_OTED_INPUT_IMPORTE')}
													name="importe_cobertura"
													value={formSolicitudOtc.importe_cobertura}
													onChange={handleInputSolicitudOtc}
													disabled={!formSolicitudOtc.poliza_externa}
													type="number"
												/>
											</Grid>
										</Grid>
									</>
								}
								
							</Grid>

							{/* Primera visita gratuita */}
							<Grid item xs={12}>
								<Divider className='mt-4 mb-4' />
								<Typography variant="subtitle1" className='mb-4 fw-500 color-primary' sx={{ mt: 2 }}>
									4.- Que el /la sotasignat, permet que s’indiqui en la seva presentació, que concedeix la primera
									visita en caràcter gratuït:
								</Typography>
								<RadioGroup
									name="primera_visita_gratuita"
									value={formSolicitudOtc.primera_visita_gratuita ? 1 : 0}
									onChange={handlePrimeraVisitaChange}
									row
								>
									<FormControlLabel value="1" control={<Radio />} label="Sí" />
									<FormControlLabel value="0" control={<Radio />} label="No" />
								</RadioGroup>
							</Grid>

							<Grid item xs={12}>
								<Stack spacing={2} className='mb-3'>
									<Typography component="p">
									  5.- Que a efectes d’obligat acompanyament i recollida d’indicadors estadístics
								      dels resultats que la <strong>Generalitat de Catalunya</strong> a través de
								      l’<strong>ICAEN</strong> demana a les <strong>OTEC</strong>, el/la sotasignat
								      es compromet a emplenar i lliurar a l’agent OTEC:{" "}
								      <strong>Francesc Vayreda</strong> (
								      <Link href="mailto:otec@ebcn.cat" underline="hover">
								        otec@ebcn.cat
								      </Link>
								      ) o <strong>John Kregel</strong> (
								      <Link href="mailto:otec-jk@ebcn.cat" underline="hover">
								        otec-jk@ebcn.cat
								      </Link>
								      ), el document anomenat{" "}
								      <Link
									        href="docsEBCN/INFORME_ETEC_form_V5.pdf"
									        target="_blank"
									        rel="noopener noreferrer"
									        underline="hover"
									      >
									      <strong>
									        “INFORME DE RECOLLIDA DE RESULTATS DE L’ENGINYER/A DE GRAU I L’ENGINYER/A
									        TÈCNIC/A ENERGÈTIC/A COL·LEGIAT/ADA (en endavant ETEC)”
									      </strong>
								      </Link>
								      , amb els indicadors sol·licitats tan bon punt es disposin.
									</Typography>

									<Typography component="p">
										6.- Que el Col·legi es compromet a incloure al/la sotasignat en el llistat de professionals <strong>ETEC</strong> i
											a fer-ne d’aquesta llista totes les campanyes de comunicació i difusió previstes i a recomanar-la
											i facilitar l’accés a totes les empreses o institucions i entitats (oficines comarcals, etc) que en
											mostrin demanda.
									</Typography>

									<Typography component="p">
										7.- Que el Col·legi analitzarà els àmbits indicats en el punt 1 de l’apartat <strong>ACORDS</strong> i, comunicarà
											al/la sotasignat d’aquells que compleixen amb les seves competències i/o atribucions.
									</Typography>
								</Stack>	
							</Grid>	


							{/* Protección de datos villate*/}
							<Grid item xs={12}>
								  <Typography variant="body2" paragraph>
							        De conformitat amb el Reglament (UE) 2016/679, de 27 d'abril de 2016, relatiu a la protecció de les persones físiques pel que fa al tractament de dades personals i a la lliure circulació d'aquestes dades i la normativa estatal que correspongui, ENGINYERS BCN, responsable del tractament, facilita la següent informació bàsica sobre Protecció de Dades:
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Responsable del Tractament:</strong><br />
							        COL·LEGI D’ENGINYERS TÈCNICS INDUSTRIALS DE BARCELONA<br />
							        Q0870003A<br />
							        Carrer Consell de Cent, 365 – 08009 de Barcelona<br />
							        ebcn@ebcn.cat<br />
							        93.496.14.20
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Finalitat del tractament de les seves dades personals:</strong><br />
							        • Gestionar les sol·licituds d’inscripció a la guia ETEC<br />
							        • Difusió de les dades de contacte i activitats professionals dels col·legiats.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Legitimació:</strong><br />
							        El tractament de les dades queda legitimat pel consentiment de l’interessat que atorga a través d’aquesta sol·licitud.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Destinataris:</strong><br />
							        Es cediran les dades a persones o empreses que ho sol·licitin amb finalitats professionals.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Drets:</strong><br />
							        Vostè podrà accedir, rectificar i suprimir les seves dades, així com exercir el dret a la limitació del tractament i la portabilitat de les dades al domicili del responsable, Carrer Consell de Cent, 365 – 08009 de Barcelona.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        – <strong>Conservació:</strong><br />
							        Les dades seran conservades durant el termini que sigui necessari per a garantir la finalitat per a la qual han estat recollides.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        ENGINYERS BCN l'informa que compleix amb tots els requisits establerts per la normativa de protecció de dades i amb totes les mesures tècniques i organitzatives necessàries per garantir la seguretat de les dades de caràcter personal.
							      </Typography>

							      <Typography variant="body2" paragraph>
							        Així mateix, en cas d'incompliment per part del responsable en el tractament de les seves dades personals, vostè té dret a interposar una reclamació davant l’Autoritat Catalana de Protecció de Dades.
							      </Typography>
							</Grid>

							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											name="acepta_condiciones"
											checked={formSolicitudOtc.acepta_condiciones}
											onChange={handleAceptaCondicionsChange}
											required
										/>
									}
									label={Lang('FORMULARIO_OTED_INPUT_CONDICIONES')}
								/>
							</Grid>

							{/* Botón de envío */}
							<Grid item xs={12}>
								<Grid container spacing={2} justifyContent="center" alignItems="center">
									<Grid item>
										<Button
											type="button"
											variant="contained"
											color="primary"
											onClick={handleGuardarSolictudSubmit}
											disabled={!formSolicitudOtc.acepta_condiciones || loadingSolicitud}
											startIcon={loadingSolicitud ? <CircularProgress size={20} thickness={4} color="inherit" /> : null}
										>
											{loadingSolicitud ? `${Lang('GENERANDO')}...` : Lang('GENERAR_DOCUMENTO')}
										</Button>

									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	)
}